/* Cart badge ping.
   Plays one soft pulse on the header cart count right after it goes up.
   On an add the drawer opens over the header, so a ping that is due while
   the drawer is open waits until it has closed. Five scripts rewrite the
   count (main-product.js, cart-components.js, cart.js, theme.js), so this
   watches the badge text instead of hooking each of them. Loaded from
   snippets/minicart.liquid; styles live in assets/minicart.css. */
(() => {
  if (window.k24CartPing) return;
  window.k24CartPing = true;

  const root = document.documentElement;
  const BADGE = '.cart-count.h-count';
  const PING = 'k24-cart-ping';
  const SETTLE_MS = 400; // gives a drawer that is about to open time to claim the screen
  const CLOSED_MS = 450; // drawer slide-out before the header is in view again

  const counts = new WeakMap();
  let pending = false;
  let timer = 0;

  const drawerOpen = () => root.classList.contains('open-minicart');

  const readCount = (badge) => {
    const text = badge.textContent.trim();
    if (text.startsWith('~')) return 100;
    const value = parseInt(text, 10);
    return Number.isNaN(value) ? null : value;
  };

  const play = () => {
    pending = false;
    document.querySelectorAll(BADGE).forEach((badge) => {
      if (!badge.getClientRects().length) return;
      badge.classList.remove(PING);
      void badge.offsetWidth; // restart when two adds land close together
      badge.classList.add(PING);
      badge.addEventListener('animationend', () => badge.classList.remove(PING), { once: true });
    });
  };

  const arm = (delay) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (pending && !drawerOpen()) play();
    }, delay);
  };

  const watch = (badge) => {
    if (counts.has(badge)) return;
    counts.set(badge, readCount(badge));
    new MutationObserver(() => {
      const before = counts.get(badge);
      const now = readCount(badge);
      counts.set(badge, now);
      if (before !== null && now !== null && now > before) {
        pending = true;
        arm(SETTLE_MS);
      }
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  };

  let wasOpen = drawerOpen();
  new MutationObserver(() => {
    const open = drawerOpen();
    if (wasOpen && !open && pending) arm(CLOSED_MS);
    wasOpen = open;
  }).observe(root, { attributes: true, attributeFilter: ['class'] });

  document.querySelectorAll(BADGE).forEach(watch);
})();
